import React, { useRef, useEffect, useContext, useState } from 'react';
import './gamepage.css';
import UserContext from '../../UserContext';
import { BASE_URL } from '../../config';

const LOAD_LOCAL_WEBGL = false; // Set to true if using local build

const GamePage = ({ onClose }) => {
    const { userInfo } = useContext(UserContext);
    const [gameSrc, setGameSrc] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const getGameUrl = async () => {
            if (!userInfo) return;

            const walletAddress = userInfo.wallet_address || userInfo.accounts || '';
            const jwt = userInfo.jwt || '';

            if (!walletAddress || !jwt) return;

            if (LOAD_LOCAL_WEBGL) {
                // Local build, no backend fetch needed
                const src = `/gamebuild/index.html?wallet=${walletAddress}&v=${Date.now()}`;
                if (isMounted) {
                    setGameSrc(src);
                    setIsLoading(false);
                }
                return;
            }

            try {
                const res = await fetch(`${BASE_URL}/get_game_url`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ address: walletAddress, jwt }),
                });
                if (!res.ok) throw new Error('Failed to fetch game URL');
                const data = await res.json();

                if (data.game_url) {
                    // Add wallet address and cache buster
                    const separator = data.game_url.includes('?') ? '&' : '?';
                    const src = `${data.game_url}${separator}wallet=${walletAddress}&v=${Date.now()}`;
                    if (isMounted) {
                        setGameSrc(src);
                        setIsLoading(false);
                    }
                } else {
                    throw new Error('No game URL returned.');
                }
            } catch (err) {
                console.error('GamePage: error loading game URL:', err);
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        };

        getGameUrl();
        return () => {
            isMounted = false;
        };
    }, [userInfo]);

    return (
        <div className="gamepage-popup-overlay">
            <div className="gamepage-popup-container">
                <button className="gamepage-close-button" onClick={onClose}>
                    CLOSE
                </button>
                <div
                    className="gamepage-popup-content"
                    style={{ height: '200vh' }}
                >
                    {isLoading ? (
                        <div style={{ color: '#fff' }}>Loading game...</div>
                    ) : (
                        <iframe
                            title="Proxima Game"
                            src={gameSrc}
                            frameBorder="0"
                            allowFullScreen
                            style={{
                                width: '100%',
                                height: '100%',
                                minHeight: 0,
                                minWidth: 0,
                                border: 'none',
                                borderRadius: '6px',
                                background: 'black'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default GamePage;
